import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function TermineBestaetigenPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [mode, setMode] = useState("");
  const [note, setNote] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/planner/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, [token]);
  const post = async (path, body, msg) => {
    setBusy(true);
    try { await api.post(`/planner/invite/${token}/${path}`, body); setDone(msg); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  const box = (children) => (
    <div className="min-h-screen bg-slate-50 flex items-start justify-center p-3 sm:p-8">
      <div className="w-full max-w-lg bg-white border border-slate-200 px-6 py-8" data-testid="termine-bestaetigen-page">
        <img src={`${process.env.REACT_APP_BACKEND_URL}/api/assets/logo-email.png`} alt="Logo" className="h-9 mb-6" />
        {children}
      </div>
    </div>
  );
  if (error) return box(<div className="text-sm text-slate-600" data-testid="tb-error">{error}</div>);
  if (!info) return box(<div className="text-xs text-slate-400">Lädt…</div>);
  const answered = done || (info.status !== "open" && (info.status === "confirmed" ? "Ihre Termine sind bestätigt." : "Ihr Änderungswunsch liegt vor."));
  if (answered) return box(
    <div className="text-center flex flex-col items-center gap-2 py-6" data-testid="tb-done">
      <CheckCircle2 size={36} strokeWidth={1.5} className="text-emerald-600" />
      <div className="font-medium text-slate-900">{answered}</div>
      <div className="text-xs text-slate-500">Sie erhalten eine Bestätigung per E-Mail bzw. neue Vorschläge von {info.coach_name || "Ihrem Coach"}.</div>
    </div>,
  );
  return box(
    <>
      <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-1 flex items-center gap-1.5"><CalendarClock size={12} /> Ihre Coachingtermine</div>
      <div className="font-heading text-2xl font-light tracking-tighter text-slate-900">Guten Tag{info.client_name ? `, ${info.client_name}` : ""}</div>
      <p className="text-sm text-slate-600 mt-2 mb-4">{info.coach_name ? `${info.coach_name} hat` : "Wir haben"} folgende Termine für Sie vorgesehen:</p>
      <ul className="space-y-2 mb-6">
        {info.slots.map((s) => <li key={s.draft_id} className="border border-slate-200 px-4 py-3 text-sm" data-testid={`tb-slot-${s.draft_id}`}>{s.label}</li>)}
      </ul>
      {mode === "change" ? (
        <>
          <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Welche Tage/Zeiten passen Ihnen besser? (optional)" className="input-tech resize-y text-sm" data-testid="tb-note" />
          <button onClick={() => post("change", { note }, "Danke! Ihr Coach meldet sich mit neuen Terminvorschlägen.")} disabled={busy}
            className="w-full mt-3 py-3 border border-slate-900 text-sm hover:bg-slate-100 disabled:opacity-50" data-testid="tb-change-submit">Änderungswunsch senden</button>
        </>
      ) : (
        <div className="grid gap-2">
          <button onClick={() => post("confirm", {}, "Vielen Dank – Ihre Termine sind verbindlich gebucht.")} disabled={busy}
            className="w-full py-4 bg-slate-900 text-white text-sm hover:bg-black disabled:opacity-50" data-testid="tb-confirm">Termine bestätigen</button>
          <button onClick={() => setMode("change")} className="w-full py-3 border border-slate-300 text-sm hover:bg-slate-100" data-testid="tb-change">Andere Termine anfragen</button>
        </div>
      )}
    </>,
  );
}
